export default __webpack_public_path__ + "static/media/plate-presentation-1.4c2b5a4a.jpg";